import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GoogleService } from '../../../services/google.service';
import { AuthService } from 'src/app/services/auth.service';
import * as dayjs from 'dayjs';
import { HourglassService } from 'src/app/services/hourglass.service';

@Component({
  selector: 'app-sql-monitor',
  templateUrl: './sql-monitor.component.html',
  styleUrls: ['./sql-monitor.component.css']
})
export class SQLMonitorComponent implements OnInit {
  @Input() showAddButton = true;
  @Input() targetObject!: string;
  @Output() calendarToEntry = new EventEmitter<string>();
  token!: string;
  authUser: any = sessionStorage.getItem('wOSUser');
  userID: any = sessionStorage.getItem('wOSImpersonate') || sessionStorage.getItem('wOSAuthUser') || "";
  dataFeed!: string;
  
  constructor(
    private hourglassService: HourglassService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.token = JSON.parse(this.authUser).stsTokenManager.accessToken;
    this.initializeSQLMonitor();
  }

  initializeSQLMonitor(): void {
    this.dataFeed = "Please complete the form and click save to continue.";
  }

  updateSQLMonitor(params: string) {
    this.dataFeed = params;
  }
}
